import {Component, Input} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {NgOptimizedImage} from "@angular/common";
import {PrimaryButtonComponent} from "../../../../../shared/components/primary-button/primary-button.component";
import {FadeInOnScrollDirective} from "../../../../../core/helpers/fade-in-on-scroll.directive";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-hero-banner',
  standalone: true,
  imports: [RouterOutlet, NgOptimizedImage, PrimaryButtonComponent, FadeInOnScrollDirective, TranslateModule],
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.scss'
})
export class HeroBannerComponent {
}
